<script>
import Button from '@/components/Button'
import ParticlesUtils from '@/utils/particlesUtils'

export default
{
    name: 'loyalty-card-reward-redeemed',

    render () 
    {
        return (
            <div id='loyalty-card-reward-redeemed-view'>
                <img class='gift-image' src={require('@/assets/img/giftbox-colorful.png')} />
                <div class='success-text'>
                    Félicitations ! Votre récompense <b>{this.reward.rewardName}</b> vous a bien été attribuée et <b>{this.store.name}</b> en a été informé.
                </div>
                <Button text='Génial' type='primary' on-click={() => this.$router.push({ name: 'LoyaltyCardOverview' })} />
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
        rewardId ()
        {
            return this.$route.params.rewardId
        },

        reward ()
        {
            return this.$store.state.storeLoyaltyCard.storeRewards[this.store.id].find(r => r.rewardId == this.rewardId)
        },

        storeId ()
        {
            return this.$route.params.storeId
        },

        store ()
        {
            return this.$store.getters.stores.getStoreById(this.storeId)
        }
    },

    mounted ()
    {
        for (let i = 0; i < 10; i++) ParticlesUtils.createParticle({ duration: [0, 4000], delay: [0, 200], text: ['🎁', '✨'], size: [50, 70] })
    },

    methods:
    {
    },

    components:
    {
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#loyalty-card-reward-redeemed-view
{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 110px;
    min-height: 80vh;

    .gift-image
    {
        width: 220px;
    }

    .success-text
    {
        text-align: center;
        font-size: 25px;
        margin-top: 30px;

        b
        {
            font-weight: bold;
        }
    }

    .button
    {
        width: -webkit-fill-available;
        margin-top: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardRewardRedeemed.vue